<template>
  <label :class="['flex items-start gap-2 text-sm cursor-pointer rounded-lg text-gray-600 font-normal', $attrs.class]">
    <input
      type="radio"
      class="radio radio-xs radio-primary mt-0.5"
      v-model="model"
      :value="value"
    />
    <slot />
  </label>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: { type: [String, Boolean] },
  value: { type: [String, Boolean] },
});

const emit = defineEmits(['update:modelValue']);

const model = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>
